import { h, Component } from 'preact';
import { translate } from 'react-i18next';

import ChangePassword from '../ChangePassword.js';
import TwoFactorStatus from '../TwoFactorStatus.js';

class Security extends Component {

	componentDidMount() {
		window.scrollTo(0,0);
	}

	render() {
		const { userData } = this.context;
		const { t } = this.props;
		return (
			<div className="view-security">
				<h1>{t('Security')}</h1>
				{(userData.accountInfo && userData.accountInfo.verified) ?
					<ChangePassword userData={this.context.userData} notification={this.props.notification} />
					:
					<p className="error-not-verified">{t('You must verify your email address before changing your password.')}</p>
				}
				<TwoFactorStatus userData={this.context.userData} />
      </div>
		);
	}
}

export default translate(['common'], { withRef: true })(Security);



// WEBPACK FOOTER //
// ./components/views/Security.js